import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import swal from "@sweetalert/with-react";

import NProgressWrapper from "@components/Common/NProgressWrapper";

import "./Login.css";
import { useFetchGlobal } from "../../api/hooks";
import { setSelectedAccount } from "../../redux/globalSlice";
import {
    setIsShopUser,
    setNumberClick,
    setOneShopSwitch,
} from "@components/VerticalLayout/store";
import { decryptWord } from "@helpers/general";
import { useDispatch } from "react-redux";
import { getListPays, processSuccessfulLogin } from "./hooks";

export default function LoginWithKC() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { fetchGlobal } = useFetchGlobal();
    const { keycloak } = useKeycloak();
    const dispatch = useDispatch();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";

    const [loading, setLoading] = React.useState<boolean>(false);

    const [, setGeneralMessageError] = React.useState<string>(t(""));

    async function checkCustomerAccountkeycloak(email: any) {
        setLoading(true);
        const urlVerifyUserAccount: string = `${process.env.REACT_APP_ACCESS_API_URL}/loginUserKc`;

        try {
            const response: any = await fetchGlobal(urlVerifyUserAccount, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: `email=${email.toLowerCase()}`,
                method: "POST",
            });
            if (response.error) {
                setLoading(false);
                const decryptEmail = decryptWord(response.data?.email);
                const decryptPwd = decryptWord(response.data?.pwd);
                if (decryptEmail === "" && decryptPwd === "") {
                    setGeneralMessageError(
                        t("Account not found. Verify your email address.")
                    );
                }
                setLoading(false);
            } else if (!response.error) {
                if (response.data?.etataccount === "Activer") {
                    processSuccessfulLogin(response, dispatch);
                    await getListPays(i18nextLng, dispatch, fetchGlobal);
                    setLoading(false);
                    if (
                        response.data.shop.AccountType?.toLowerCase() ===
                        "boutique"
                    ) {
                        dispatch(
                            setSelectedAccount(
                                response.data.shop.CommercialName
                            )
                        );
                        setOneShopSwitch(
                            response.data.shop.uuidFranchise,
                            response.data.shop.uid,
                            response.data.shop.country,
                            response.data.shop.CommercialName
                        );

                        setNumberClick(0);
                        setIsShopUser(true);
                        navigate("/compte");
                    } else {
                        setIsShopUser(false);
                        navigate("/compte");
                    }
                } else {
                    return swal({
                        icon: "error",
                        content: <p>{t("There's an error")!}</p>,
                        buttons: false,
                        timer: 2000,
                    });
                }
            }
        } catch (error) {
            setLoading(false);
            return false;
        }
    }

    React.useEffect(() => {
        const uidEntity = localStorage.getItem("Uid_Entitie_User");

        if (uidEntity !== null && uidEntity === keycloak.tokenParsed?.uuid) {
            navigate("/compte");
        } else if (keycloak.authenticated) {
            checkCustomerAccountkeycloak(keycloak.tokenParsed?.email);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Container fluid={true} className="p-0 m-0 overflow-hidden">
            <NProgressWrapper isLoading={loading} />
        </Container>
    );
}
